module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Edit category","eventsCategoriesActionsEditOneSuccess":"%{eventsCategoryName} was successfully updated in the database"},"no":{"dialogTitle":"Rediger kategori","eventsCategoriesActionsEditOneSuccess":"%{eventsCategoryName} ble redigert i databasen"}}')
  delete Component.options._Ctor
}
